<template>
    <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.83569 20.7344H7.67618C6.50516 20.7344 5.58466 21.736 5.68329 22.9028L6.80455 36.1684C6.89208 37.204 7.75818 38 8.79745 38H61.016C62.0461 38 62.9077 37.2176 63.0068 36.1923L64.2882 22.9267C64.4017 21.7516 63.478 20.7344 62.2975 20.7344H61.5813M8.83569 20.7344L12.0683 13.2105C12.3838 12.476 13.1064 12 13.9058 12H56.3311C57.116 12 57.8284 12.4591 58.1525 13.174L61.5813 20.7344M8.83569 20.7344H61.5813M30.1007 26.4219H38.4399" stroke="currentColor" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGDrawer',
};
</script>

<style scoped lang="scss">

</style>
